<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Lista de cupones</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
            <router-link class="btn btn-success" :to="{ name: 'pos-cuponera-nuevo', params: {} }">
              <i class="fa fa-plus"></i>
              &nbsp;
              Agregar nuevo cupón
            </router-link>
              <a class href="#"></a>
              <a v-if="mostrarRefresh" class="btn btn-sm btn-info" @click="refreshData" href="#">Refresh</a>
            </div>
             <div class="col-sm-12">
              <div class="form-inline justify-content-sm-end">
                <input class="form-control form-control-sm rounded bright" placeholder="Filtrar Numero"
                  v-model="filter.numero" type="text" v-on:keyup.enter="filterData(1)" />
                <input class="form-control form-control-sm rounded bright" v-model="filter.fecha_inicio" type="date"
                  v-on:keyup.enter="filterData(1)" />
                <input class="form-control form-control-sm rounded bright" placeholder="Buscar nombre"
                  v-model="filter.searchtext" type="text" v-on:keyup.enter="filterData(1)" />
                <select class="form-control form-control-sm rounded bright" v-model="filter.estatus"
                  @change="filterData(1)">
                  <option value>Todos</option>
                  <option :value="true">Activo</option>
                  <option :value="false">Inactivo</option>
                </select>
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="button" @click="filterData(1)">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CuponeraTableComponent :dataTabla="dataTabla" :refreshData="filterData" @setActualPage="setPage"/>
      </div>  
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import CuponeraTableComponent from "@/components/pos/cuponera/CuponeraTableComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    CuponeraTableComponent,
    UsuarioEnTablaComponent,
    PaginationComponent,
  
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      dataTabla: "",
      filter: {
        tienda: "",
        estatus: "",
        searchtext: "",
        usuario: "",
        estado: "A",
        proveedor: "",
        fecha: "",
      },
      data:[],
    };
  },
  computed: {},
  mounted() {
    this.filterData();   
     },
  methods: {
    setPage(newPage){      
      this.currentPage = newPage
    },

    filterData(page) {         
      let fechaInicio
        if (this.filter.fecha_inicio) {    
        fechaInicio = moment(this.filter.fecha_inicio).format(
          "DD/MM/YYYY"
        );
      }   
      DynamicService.fetch("cat", "cuponera", {
        page: page ? page:this.currentPage,
        "filter[search]": this.filter.searchtext,
        id: this.filter.numero,
        estatus: this.filter.estatus,
        fecha_inicio: fechaInicio,
      }).then((response) => {
        this.dataTabla = response.data;
      });
    },
    clearFilterData() {
      this.filter.searchtext = "";
      this.$data.currentPage = 1;
      this.filter.numero = "";
      this.filter.estatus = "";
      this.filter.fecha_inicio = "";
      DynamicService.fetch("cat", "cuponera").then((response) => {
        this.dataTabla = response.data;
      });
    },
  },
};
</script>
